<div class="hub-selection">
  <!-- Option Cards with Icons -->
  <div class="hub-options">
    <div class="hub-option" [class.hub-option--active]="selectedOption === 'join'" (click)="selectOption('join')">
      <div class="hub-option__icon"><i class="pi pi-users"></i></div>
      <p class="hub-option__title">Beitreten</p>
      <p class="hub-option__desc">Mit Einladungscode</p>
    </div>
    <div class="hub-option" [class.hub-option--active]="selectedOption === 'create'" (click)="selectOption('create')">
      <div class="hub-option__icon"><i class="pi pi-plus"></i></div>
      <p class="hub-option__title">Erstellen</p>
      <p class="hub-option__desc">Neue Kommune anlegen</p>
    </div>
  </div>

  <!-- Join Form -->
  <div *ngIf="selectedOption === 'join'">
    <form [formGroup]="joinForm!">
      <div class="hub-field">
        <label>Einladungscode</label>
        <input type="text" placeholder="ABC-123-XYZ" formControlName="join_code" style="text-transform: uppercase; letter-spacing: 2px;"/>
      </div>
    </form>
  </div>

  <!-- Create Form -->
  <div *ngIf="selectedOption === 'create'">
    <form [formGroup]="hubForm!">
      <!-- Basic Info -->
      <div class="hub-form-section">
        <h4 class="hub-form-section__title">Basis-Informationen</h4>
        <div class="hub-row">
          <div class="hub-field">
            <label>Kommunenart</label>
            <select formControlName="hub_type">
              <option value="" disabled>Bitte auswählen</option>
              <option *ngFor="let type of hubTypes" [value]="type.value">{{type.name}}</option>
            </select>
          </div>
        </div>
        <div class="hub-row">
          <div class="hub-field">
            <label>Name der Kommune</label>
            <input type="text" placeholder="z.B. Gemeinde Musterstadt" formControlName="hub_name"/>
          </div>
        </div>
      </div>

      <hr class="hub-divider"/>

      <!-- Address -->
      <div class="hub-form-section">
        <h4 class="hub-form-section__title">Adresse</h4>
        <div class="hub-row">
          <div class="hub-field">
            <label>Straße und Hausnummer</label>
            <input type="text" placeholder="Hauptstraße 1" formControlName="hub_street"/>
          </div>
        </div>
        <div class="hub-row">
          <div class="hub-field hub-field--small">
            <label>PLZ</label>
            <input type="text" placeholder="12345" formControlName="hub_postal" maxlength="5"/>
          </div>
          <div class="hub-field">
            <label>Stadt</label>
            <input type="text" placeholder="Musterstadt" formControlName="hub_city"/>
          </div>
        </div>
      </div>

      <hr class="hub-divider"/>

      <!-- Contact -->
      <div class="hub-form-section">
        <h4 class="hub-form-section__title">Kontakt <span>Optional</span></h4>
        <div class="hub-row">
          <div class="hub-field">
            <label>Telefon</label>
            <input type="tel" placeholder="+49 123 456789" formControlName="hub_tel"/>
          </div>
          <div class="hub-field">
            <label>Website</label>
            <input type="url" placeholder="www.beispiel.de" formControlName="hub_website"/>
          </div>
        </div>
        <div class="hub-row">
          <div class="hub-field">
            <label>Beschreibung</label>
            <textarea placeholder="Kurze Beschreibung der Kommune..." formControlName="hub_description"></textarea>
          </div>
        </div>
      </div>

      <hr class="hub-divider"/>

      <!-- Logo -->
      <div class="hub-form-section">
        <h4 class="hub-form-section__title">Logo <span>Optional</span></h4>
        <div class="hub-logo">
          <div class="hub-logo__preview">
            <img *ngIf="hubAvatarPreview" [src]="hubAvatarPreview" alt="Logo"/>
            <i *ngIf="!hubAvatarPreview" class="pi pi-image"></i>
          </div>
          <div class="hub-logo__actions">
            <button type="button" class="hub-logo__btn hub-logo__btn--upload" (click)="triggerLogoUpload()">
              {{ hubAvatarPreview ? 'Ändern' : 'Hochladen' }}
            </button>
            <button *ngIf="hubAvatarPreview" type="button" class="hub-logo__btn hub-logo__btn--remove" (click)="removeHubAvatar()">
              Entfernen
            </button>
          </div>
          <input type="file" #logoInput accept="image/*" style="display: none" (change)="onLogoSelect($event)"/>
        </div>
      </div>

      <hr class="hub-divider"/>

      <!-- Hours -->
      <div class="hub-form-section">
        <h4 class="hub-form-section__title">Öffnungszeiten <span>Optional</span></h4>
        <label class="hub-toggle">
          <input type="checkbox" formControlName="is_24_7"/>
          <span class="hub-toggle__track"></span>
          <span class="hub-toggle__label">Rund um die Uhr erreichbar (24/7)</span>
        </label>

        <div *ngIf="!hubForm?.get('is_24_7')?.value" class="hub-hours">
          <div *ngFor="let day of weekDays" class="hub-hours__row" [class.hub-hours__row--disabled]="day.closed">
            <span class="hub-hours__day">{{day.label}}</span>
            <label class="hub-hours__closed">
              <input type="checkbox" [(ngModel)]="day.closed" [ngModelOptions]="{standalone: true}"/>
              <span>Geschlossen</span>
            </label>
            <div class="hub-hours__times">
              <input type="time" [(ngModel)]="day.open" [ngModelOptions]="{standalone: true}"/>
              <span>bis</span>
              <input type="time" [(ngModel)]="day.close" [ngModelOptions]="{standalone: true}"/>
            </div>
          </div>
        </div>
      </div>
    </form>
  </div>
</div>
